import React from 'react';

export const RequestHistoryCommentsCard = ({ comments }) => (
    <div className="card p-3 mb-3 h-100">
        <h5 className="text-strong mb-3">Request History & Comments</h5>
        <label className="d-block text-muted">Comments</label>
        <div>{comments}</div>
    </div>
);
